// @ngInject
function stateConfig($stateProvider) {

    $stateProvider.state('base.customergroups.new', {
        url:'/new',
        views: {
            'baseView@base': {
            templateUrl: 'main/base/customergroups/customergroup/customergroup.tpl.html',
            controller: 'CustomerGroupController as vm'
        }},
        resolve: {
            customergroup: function() { return {}; },
            isNewCustomerGroup: function() {return true;}
        }
    });

    $stateProvider.state('base.customergroups.customergroup', {
        url:'/{customergroupId}',
        views: {
            'baseView@base': {
            templateUrl: 'main/base/customergroups/customergroup/customergroup.tpl.html',
            controller: 'CustomerGroupController as vm'
        }},
        resolve: {
            customergroup: customergroupResolver,
            isNewCustomerGroup: function() {return false;}
        }
    });

}

// @ngInject
function customergroupResolver($stateParams, CustomerGroupsApiService) {
    return CustomerGroupsApiService.getCustomerGroup($stateParams.customergroupId);
}

// @ngInject
function languagesResolver($stateParams, CustomerGroupsApiService) {
    return CustomerGroupsApiService.getLanguages();
}

// @ngInject
function CustomerGroupController($state, customergroup, loadSpinnerService, CustomerGroupsApiService, ToasterService, confirmationDialogService, $translate, isNewCustomerGroup) {
    var vm = this;

    var customergroupCopy = {};

    vm.customergroup = customergroup;

    vm.enableEditing = enableEditing;
    vm.cancelEditing = cancelEditing;
    vm.saveCustomerGroup = saveCustomerGroup;
    vm.deleteCustomerGroup = deleteCustomerGroup;

    vm.isNewCustomerGroup = isNewCustomerGroup;
    vm.isEditing = vm.isNewCustomerGroup;
    vm.devFeaturesEnabled = localStorage.getItem('devFeature_reactCustomerGroupView') === 'true';
    vm.reactCustomerGroupId = isNewCustomerGroup ? null : (customergroup && customergroup.id != null ? customergroup.id : null);

    vm.isCustomerGroupCodeValid = isCustomerGroupCodeValid;
    vm.isAllInformationValid = isAllInformationValid;

    vm.toggleDisplayForm = toggleDisplayForm;

    activate();

    function activate() {
        prepareData();
        if (vm.isNewCustomerGroup) {
            vm.customergroup = {};
        }

    }

    function enableEditing() {
        customergroupCopy = angular.copy(vm.customergroup);
        vm.isEditing = true;
    }

    function cancelEditing() {
        vm.customergroup = customergroupCopy;
        vm.isEditing = false;
    }

    function saveCustomerGroup() {
        if (vm.isNewCustomerGroup) {
            saveNewCustomerGroup();
        } else {
            updateCustomerGroup();
        }
    }

    function saveNewCustomerGroup() {
        loadSpinnerService.start('mainSpinner');
        CustomerGroupsApiService.createCustomerGroup(vm.customergroup).then(function(response) {
            vm.customergroup = response;
            prepareData();
            vm.isNewCustomerGroup = false;
            vm.isEditing = false;
            $state.go('base.customergroups.customergroup', {customergroupId: vm.customergroup.id});
        }, function(error) {
            console.log(error);
            ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
        }).then(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function updateCustomerGroup() {
        loadSpinnerService.start('mainSpinner');

        CustomerGroupsApiService.updateCustomerGroup(vm.customergroup).then(function(response) {
            vm.customergroup = response;
            prepareData();
            vm.isNewCustomerGroup = false;
            vm.isEditing = false;
            $state.go('base.customergroups.customergroup', {customergroupId: vm.customergroup.id});
        }, function(error) {
            console.log(error);
            ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
        }).then(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function deleteCustomerGroup() {
        confirmationDialogService
            .showDialog($translate.instant('customergroup.confirmDelete'))
            .then(function(confirmation) {
                if (confirmation) {
                    loadSpinnerService.start('mainSpinner');
                    CustomerGroupsApiService.deleteCustomerGroup(vm.customergroup.id).then(function(response) {
                        vm.customergroup = response;
                        prepareData();
                        vm.isNewCustomerGroup = false;
                        vm.isEditing = false;
                        $state.go('base.customergroups');
                    }, function(error) {
                        console.log(error);
                        ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
                    }).then(function() {
                        loadSpinnerService.stop('mainSpinner');
                    });
                }
            });
    }

    function toggleDisplayForm(customergroup) {
        customergroup.showEditForm = !customergroup.showEditForm;
    }

    function prepareData() {
        if (vm.customergroup === undefined) {
            return;
        }

        vm.customergroupCopy = angular.copy(vm.customergroup);
    }

    function isAllInformationValid() {
        return isCustomerGroupCodeValid();
    }

    function isCustomerGroupCodeValid() {
        if (!vm.customergroup.code) { return false; }
        if (vm.customergroup.code.length > 20) { return false; }

        return true;
    }

    function isNumeric(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }

}

angular
    .module('customergroups.customergroup', [])
    .config(stateConfig)
    .controller('CustomerGroupController', CustomerGroupController);
